import { UserRole } from "graphql/generated";

type RoleLike = UserRole | string | null | undefined;

export const isDoctorRole = (role: RoleLike): boolean =>
  role === UserRole.Doctor || role === UserRole.TestDoctor;

export const isPatientRole = (role: RoleLike): boolean =>
  role === UserRole.Patient || role === UserRole.TestPatient;

export const isAdminRole = (role: RoleLike): boolean => role === UserRole.Admin;

export const isTestRole = (role: RoleLike): boolean =>
  role === UserRole.TestDoctor || role === UserRole.TestPatient;
